<div
    class="full-modal-config__section"
    provideParentForm
>
    <h3>{{ l10nKeys.sectionTitleUdp | vtranslate }}</h3>
    <health-monitor-port-ip-group [editable]="editable"></health-monitor-port-ip-group>

   <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6>{{ l10nKeys.clientRequestHeaderInputLabel | vtranslate }}</h6>
            <newline-converted-textarea
                name="udp-request"
                objectType="{{ objectTypes.HealthMonitorUdp }}"
                fieldName="udp_request"
                [(ngModel)]="udpMonitor.config.udp_request"
                required
                placeholder="{{ l10nKeys.clientRequestHeaderInputPlaceholder | vtranslate }}"
            ></newline-converted-textarea>
        </div>
    </div>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6>{{ l10nKeys.serverResponseDataInputLabel | vtranslate }}</h6>
            <newline-converted-textarea
                name="udp-response"
                objectType="{{ objectTypes.HealthMonitorUdp }}"
                fieldName="udp_response"
                [(ngModel)]="udpMonitor.config.udp_response"
                placeholder="{{ l10nKeys.serverResponseDataInputPlaceholder | vtranslate }}"
            ></newline-converted-textarea>
        </div>
    </div>
</div>
